export async function getToken() {
  try {
    const clientId = process.env.JANE_CLIENT_ID;
    const clientSecret = process.env.JANE_CLIENT_SECRET;

    const result = await fetch(`https://www.iheartjane.com/api/oauth/token?grant_type=client_credentials&client_id=${clientId}&client_secret=${clientSecret}`, {
      method: 'POST',
      headers: {
        accept: 'application/json'
      }
    });

    if (!result.ok) {
      throw new Error(`Error fetching token: ${result.status}`);
    }

    const data = await result.json();
    return data;
  } catch (error) {
    console.error('Error retrieving token:', error);
    throw error;
  }
}

export default async function handler(req, res) {
  const data = await getToken();
  res.status(200).json(data);
}